<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
        :is_show_chart_dialog="is_show_chart_dialog"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #description>
            <v-btn 
                class="switch-btn"
                @click="switch_show_header"
            >
                切換表格單位
            </v-btn>
        </template>

        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_draw_diagram_header="should_draw_diagram_header"
                :enable_diagram_slot="true"
                :show_description_dialog_btn="false"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
                @open-chart="assign_chart_component"
                :is_show_chart_dialog_parent.sync="is_show_chart_dialog"
            >
                <template #diagram_dialog="{ close_dialog }">
                    <template v-if="history_data_loaded && is_show_chart_dialog">
                        <MonitorTide
                            :timeseries_data="history_data" 
                            :default_variable="tide_history_option"
                            @close-chart-dialog="close_dialog"
                        />
                    </template>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax, sort_monitor_table_page_data, station_history_ajax } from "@/utils/monitor/monitor.js"
    import { filter_same_district } from '@/utils/monitor/customization/port.js'
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import { mapState } from 'vuex' 
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue"

    export default {

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable, 
            MonitorTide: () => import('@/components/chart/monitor_tide.vue')
        },
        
        mixins: [monitor_mixin],

        props: {
            default_value: {
                type: Number,
                required: true,
            },

            activate_filter_by_parent: {
                type: Boolean,
                default: false
            },

            filter_value_from_parent: {
                type: String,
                default: ''
            }
        },

        data() {
            return {
                header: [],
                table_data: [],
                error_text: '',
                immutable_table_data: [],

                should_draw_diagram_header: ['平均風(m/s)', '風向(十六方位)', '氣壓(hPa)', '氣溫(℃)', '海溫(℃)', '潮高(m)'],

                is_show_chart_dialog: false,
                history_data: [],
                current_table_header: '',
                tide_history_option: '',
                history_data_loaded: false,

                current_table_reference_key: null,
            }
        },
        
        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },

        watch: {
            immutable_table_data: {
                handler() {
                    if (Object.keys(this.immutable_table_data).length === 0) return
                    this.activate_filter_by_parent && this.$emit('collect_data', this.immutable_table_data)
                },
                deep: true
            },

            filter_value_from_parent() {
                this.table_data = filter_same_district(this.immutable_table_data, this.filter_value_from_parent)
            }
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
            this.current_table_reference_key = this.default_value
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = this.filter_value_from_parent 
                    ? filter_same_district(this.immutable_table_data, this.filter_value_from_parent)
                    : data
                this.header = header;
            },

            assign_chart_component(header_name, choosed_value, current_row_data) {
                this.current_table_header = header_name
                this.tide_history_option = this.current_table_header.split('(')[0].trim()
                this.history_data_loaded = false
                const call_history_time = `${this.date} ${this.time}:00`;
                station_history_ajax.call(this, current_row_data['站號'], call_history_time, 'tide')
            },

            switch_show_header() {
                let change_reference_key 
                if (this.current_table_reference_key === this.default_value) {
                    change_reference_key = this.default_value === 113 ? 'tide_level_pro' : 'tide_level'
                } else {
                    change_reference_key = this.default_value
                }
                sort_monitor_table_page_data.call(this, this.immutable_table_data, change_reference_key)
                this.current_table_reference_key = change_reference_key
            },
        },
    }
</script>

<style scoped>
    .switch-btn {
        margin: auto;
        padding: 0 .5rem;
        height: 24px;
        font-size: small;
        line-height: 24px;
        color: #fff;
        background: #3575c8 !important;
        border-radius: 5px;
    }
</style>